export enum UserGroups {
  TEMP_PACKAGE_GROUP = 'Temp_package_group',
}

export const UserGroupsDisplays: { key: UserGroups, value: string }[] = [
  { key: UserGroups.TEMP_PACKAGE_GROUP, value: 'Temp_package_group' },
];
